export default {
    'profile.page_title': 'Profile',

    'profile.link.title.profile': 'Profile',
    'profile.link.description.profile': 'Update your name, email address, and password.',

    'profile.button.update': 'Update profile',
    'profile.button.password_update': 'Update password',

    'profile.success.message.password_updated': 'Your password was successfully updated',
    'profile.success.message.profile_updated': 'Your profile was successfully updated',
};
